import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Filter, Download } from "react-feather";
import { Dropdown } from "react-bootstrap";
import * as XLSX from "xlsx";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

const BillToShipTo = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [paymentFilter, setPaymentFilter] = useState("All");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [orderIdSearch, setOrderIdSearch] = useState("");

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllOrders`);
        const data = response.data.orders || [];
        setOrders(data);
        setFilteredOrders(data);
      } catch (error) {
        console.error("Error fetching orders:", error);
        Swal.fire("Error", "Failed to load orders", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  useEffect(() => {
    let filtered = [...orders];

    if (search) {
      const lowerSearch = search.toLowerCase();
      filtered = filtered.filter(
        (order) =>
          order.order_unique_id?.toLowerCase().includes(lowerSearch) ||
          order.cart_items?.some((item) =>
            item.title?.toLowerCase().includes(lowerSearch)
          )
      );
    }

    if (orderIdSearch) {
      filtered = filtered.filter((order) =>
        order.order_unique_id
          ?.toLowerCase()
          .includes(orderIdSearch.toLowerCase())
      );
    }

    if (paymentFilter !== "All") {
      filtered = filtered.filter(
        (order) => order.payment_method === paymentFilter
      );
    }

    if (startDate && endDate) {
      filtered = filtered.filter((order) => {
        const orderDate = new Date(order.created_at);
        return orderDate >= startDate && orderDate <= endDate;
      });
    }

    setFilteredOrders(filtered);
  }, [search, orderIdSearch, paymentFilter, startDate, endDate, orders]);

  const handleDownloadExcel = () => {
    const dataToExport = [];

    orders.forEach((order) => {
      order.cart_items?.forEach((item) => {
        dataToExport.push({
          "Order ID": order.order_unique_id,
          "Total (₹)": parseFloat(order.total).toFixed(2),
          "Payment Method": order.payment_method,
          "Order Date": new Date(order.created_at).toLocaleString(),
          "Item Title": item.title,
          Quantity: item.quantity,
          "Price (₹)": item.price,
          "Delivery Charge (₹)": item.delivery_charge,
          "Delivery Method": item.delivery_method,
          "Shipping Name": order.shipping_address?.full_name,
          "Shipping City": order.shipping_address?.city,
        });
      });
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "All Orders");
    XLSX.writeFile(wb, "all_orders.xlsx");
  };

  const paymentMethods = [
    ...new Set(orders.map((order) => order.payment_method)),
  ];

  return (
    <div className="App d-flex">
      <AdminSidebar />
      <div className="content flex-grow-1 p-3">
        <AdminTopbar />
        <div className="container-fluid">
          <h4 className="text-start mb-3">All Ship To List</h4>
          <div className="row g-1 mb-3">
            <div className="col-md-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Product Title"
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Order ID"
                onChange={(e) => setOrderIdSearch(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText="Start Date"
                className="form-control"
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                placeholderText="End Date"
                className="form-control"
              />
            </div>
            <div className="col-md-2">
              <select
                className="form-control"
                value={paymentFilter}
                onChange={(e) => setPaymentFilter(e.target.value)}
              >
                <option value="All">All Payment</option>
                {paymentMethods.map((method, idx) => (
                  <option key={idx} value={method}>
                    {method}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <button
                className="btn btn-success w-100"
                onClick={handleDownloadExcel}
              >
                <Download size={17} /> Download
              </button>
            </div>
          </div>

          <div className="table-responsive">
            {loading ? (
              <p>Loading orders...</p>
            ) : filteredOrders.length === 0 ? (
              <p>No orders found.</p>
            ) : (
              <table className="custom-table">
                <thead className="">
                  <tr>
                    <th>#</th>
                    <th>Order ID</th>
                    <th>Total (₹)</th>
                    <th>Payment</th>
                    <th>Date</th> 
                    <th>Shipping Info</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrders.map((order, index) => (
                    <tr key={order.order_id}>
                      <td>{index + 1}</td>
                      <td>{order.order_unique_id}</td>
                      <td>{parseFloat(order.total).toFixed(2)}</td>
                      <td>{order.payment_method}</td>
                      <td>
                        {new Date(order.created_at).toLocaleDateString("en-GB")}
                      </td>
                      

                      <td>
                        {order.shipping_address?.full_name},{" "}
                        {order.shipping_address?.city}
                      </td>
                      <td>
                        <div className="d-flex ">
                          {/* <Link
                          to={`/order-details/${order.order_unique_id}/00`} target="_blank"
                          className="btn btn-sm btn-primary me-2"
                        >
                            Details
                        </Link> */}

                          <Link
                            to={`/performa-invoice/${order.order_unique_id}`}
                            target="_blank"
                            className="btn btn-sm btn-info"
                          >
                            Invoice
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillToShipTo;
